export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-5 py-10">
        <h1 className="font-heading text-2xl font-semibold mb-2">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: June 6, 2026</p>

        <div className="space-y-8 text-sm leading-relaxed text-foreground/80">
          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">1. Introduction</h2>
            <p>Signature Coffee Note ("the Service") respects your privacy and is committed to protecting your personal information. This policy explains what information we collect, how we use it, and the measures we take to keep it safe.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">2. Information We Collect</h2>
            <p className="mb-2">We may collect the following types of information:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Email address and display name (when creating an account)</li>
              <li>User-generated content such as reviews, ratings, and photos</li>
              <li>Location-related data used for cafe searches via Google Maps API</li>
              <li>Usage data including access logs and device information</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">3. How We Use Your Information</h2>
            <p className="mb-2">Collected information is used for the following purposes:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Creating and managing your account</li>
              <li>Providing coffee reviews and cafe information</li>
              <li>Improving the Service and developing new features</li>
              <li>Responding to inquiries and support requests</li>
              <li>Detecting and preventing unauthorized access or abuse</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">4. Sharing with Third Parties</h2>
            <p>We do not sell or share your personal information with third parties, except as required by law or through the following service integrations:</p>
            <ul className="list-disc list-inside space-y-1 pl-2 mt-2">
              <li>Google Maps Platform (for location search and map display)</li>
              <li>Authentication providers (when using Google Sign-In)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">5. Data Storage and Security</h2>
            <p>Your data is stored on secure servers. We implement appropriate technical and organizational measures to protect against unauthorized access, disclosure, or alteration of your information.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">6. Your Rights</h2>
            <p className="mb-2">You may request the following at any time:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Access to or confirmation of the personal data we hold about you</li>
              <li>Correction or deletion of inaccurate information</li>
              <li>Deletion of your account and associated data</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">7. Cookies</h2>
            <p>The Service may use cookies to maintain your login session and improve usability. You can disable cookies in your browser settings, though some features may not function as expected.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">8. Changes to This Policy</h2>
            <p>We may update this policy from time to time. If significant changes are made, we will notify you through the Service.</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-base text-foreground mb-3">9. Contact</h2>
            <p>If you have any questions about this Privacy Policy, please reach out through the contact feature within the Service.</p>
          </section>
        </div>
      </div>
    </div>
  );
}